import React,{ useState,useEffect} from 'react'
import DataTable from '../Components/Molecules/Table/DataTable'

import _ from "lodash";
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import RadioButton from "../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
//import styles from "./Dashboard.module.scss";
import HBar from "../Components/Bars/Bars";
import {add_branch_user_api,branch_list,customer_list,get_master_data} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";

export default function ApplicationsList() {
const [branchList, setBranchList] = useState([])
const  [selectedRow, setSelectedRow] = useState(null)
const [OpenForm,setOpenForm] = useState(0)
const userData = useSelector((state) => state.auth.user);
const [filterData,setFilterData] = useState({"page":1,"per_page":25,"role_id":[3],"search_string":""}
)

const [serviceTypes,setServiceTypes] = useState([])
const [selectedServiceType, setSelectedServiceType] = useState(null)
const getMasterData = ()=>{
  let postData = {"categories":["md_service_types"]};
  //values["tenant_id"] = _.get(selectedTenant,"id");
   postMethod(get_master_data,postData).then((res)=>{
    

   let md_service_types =   _.get(res,"result.md_service_types",[]).map((item)=>{
      item["label"] =  item["name"]
      
      return item
    });
    setServiceTypes(md_service_types)
    
  })
}
useEffect(()=>{
  getMasterData()
},[])
  const columnDefs = [
    { headerName: "ID", field: "index" ,width: 80},
    { headerName: "Name", field: "first_name", minWidth:150},
    { headerName: "Email", field: "email",minWidth:150 },
    { headerName: "Phone", field: "mobile_no",minWidth:150 },
    { headerName: "Status", field: "status_details.name",minWidth:150 },
    { headerName: "Service", field: "service_details.name",maxWidth:100 },
   
  ];

  columnDefs.push( { headerName: "Actions", field: "actions",maxWidth:10000 },)

  const [isSpinner, setIsSpinner] = useState(false);
  const handleSubmit = (values) => {
    setIsSpinner(true);
    
     values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(add_branch_user_api,values).then((res)=>{
      console.log(res)
      setOpenForm(0)
      setIsSpinner(false);
    }).catch ((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

    })
  };

  const [selectedTenant, setSelectedTenant ] = useState(()=>{
    if(_.get(userData, "tenant_details",null) !=null){
        return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
     
      
    }else{
      return null
    }
      
  })
  const getBranchList = ()=>{
    let postData = {
      "search_string": "",
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "status_ids": []
    }
    postMethod(branch_list,postData).then((res)=>{
      if(_.get(res, "list.length") >0){
        let list = res["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        setBranchList(list);
      }
      
    })

  }
  useEffect(()=>{
    //if(OpenForm ==1 && _.get(userData,"role_id") ==1){
      getBranchList();
    //}
    
  },[OpenForm])

  /*
  
  {
  "email": "user@example.com",
  "first_name": "string",
  "last_name": "string",
  "mobile_no": "string",
  "experience": 0,
  "profile_image": "string",
  "role_id": 0,
  "tenant_id": 0
}
  */
 let formData = {
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required")
    .min(2, "Must be at least 2 characters")
    .max(50, "Must be 50 characters or less"),
  first_name: Yup.string()
    .required("First name is required")
    .min(2, "Must be at least 2 characters")
    .max(50, "Must be 50 characters or less"),
  last_name: Yup.string()
    .required("Last name is required")
    .min(1, "Must be at least 2 characters")
    .max(50, "Must be 50 characters or less"),
  mobile_no: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9 + -]+$/, "Only numbers are allowed")
    .min(10, "Must be at least 10 characters")
    .max(15, "Must be 15 characters"),
  service:  Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")
  
}
let initialValues ={
  first_name: "",
  last_name: "",
  email: "",
  service: "",
  mobile_no: "",
  tenant_id:_.get(selectedTenant,"name","somthing")
  
}
if(_.get(userData,"role_id") ==1){
  formData["tenant_id"] = Yup.string()
  .required("Branch is required")
  //.matches(/^[1-9 + -]+$/, "Only numbers are allowed")
  //initialValues["tenant_id"] = _.get(selectedTenant,"name","somthing")
}

  let formik = useFormik({
    initialValues:initialValues,
    validationSchema: Yup.object(formData),
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: true,
  });

  
  const getDetails = (row)=>{
    /*
    email:''
     first_name: "",
  last_name: "",
  mobile_no: "",
  experience: "",
    */
    setSelectedRow(row)
    formik.setFieldValue("email", _.get(row,"email",""))
    formik.setFieldValue("first_name", _.get(row,"first_name",""))
    formik.setFieldValue("last_name", _.get(row,"last_name",""))
    formik.setFieldValue("mobile_no", _.get(row,"mobile_no",""))
    formik.setFieldValue("experience", _.get(row,"experience",""))
    if(_.get(row,"admin_tenant_details",false)){
      setSelectedTenant(row["admin_tenant_details"])
      formik.setFieldValue("tenant_id", _.get(row,"admin_tenant_details.name",""))
    }
    
   
    setOpenForm(1)

  }

  useEffect(()=>{
    if(OpenForm !=1){
      formik.resetForm();
      setSelectedRow(null)
    }
   
  },[OpenForm])

  
  return (
    <div>
       <h3>Loan Applications </h3>
        <div className={'mt-3'}>
           {OpenForm ==0 && <DataTable loaded_from="CUSTOMERS_LIST" columnDefs={columnDefs} apiUrl={customer_list} setFilterData={setFilterData} filterData={filterData} setOpenForm={(v)=>{ setOpenForm(1)}} editRow={(item)=>{getDetails(item)}} showCreateBtn={true} />}
          
          {/*Create form 
          
          email: "",
      first_name: "",
      last_name: "",
      mobile_no: "",
      experience: "",
      role_id: 3,
          
          */}
          { OpenForm ==1 && <>
            <Card className="">
            <div className="pt-1">
            {/* First Row */}
              <div className="row">
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Email"
                    id="email"
                    name="email"
                    type="text"
                    value={formik.values.email}
                    onChange={(e) =>
                      formik.setFieldValue("email", e.target.value)
                    }
                    error={formik.touched.email && formik.errors.email}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && (
                    <ErrorLabel
                      name="email"
                      formik={formik}
                      message={formik.errors.email}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="First Name"
                    id="first_name"
                    name="first_name"
                    type="text"
                    value={formik.values.first_name}
                    onChange={(e) =>
                      formik.setFieldValue("first_name", e.target.value)
                    }
                    error={formik.touched.first_name && formik.errors.first_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.first_name && (
                    <ErrorLabel
                      name="first_name"
                      formik={formik}
                      message={formik.errors.first_name}
                    />
                  )}
                </div>

                <div className="col-md-4 mb-2">
                  <FormField
                    label="Last Name"
                    id="last_name"
                    name="last_name"
                    type="text"
                    value={formik.values.last_name}
                    onChange={(e) =>
                      formik.setFieldValue("last_name", e.target.value)
                    }
                    error={formik.touched.last_name && formik.errors.last_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.last_name && (
                    <ErrorLabel
                      name="last_name"
                      formik={formik}
                      message={formik.errors.last_name}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Mobile Number"
                    id="mobile_no"
                    name="mobile_no"
                    type="text"
                    value={formik.values.mobile_no}
                    onChange={(e) =>
                      formik.setFieldValue("mobile_no", e.target.value)
                    }
                    error={formik.touched.mobile_no && formik.errors.mobile_no}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.mobile_no && (
                    <ErrorLabel
                      name="mobile_no"
                      formik={formik}
                      message={formik.errors.mobile_no}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Experience"
                    id="experience"
                    name="experience"
                    type="text"
                    value={formik.values.experience}
                    onChange={(e) =>
                      formik.setFieldValue("experience", e.target.value)
                    }
                    error={formik.touched.experience && formik.errors.experience}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.experience && (
                    <ErrorLabel
                      name="experience"
                      formik={formik}
                      message={formik.errors.experience}
                    />
                  )}
                </div>

                <div className="col-md-4 mb-2">
                  <FormDropdown
                    id="tenant_id"
                    name="tenant_id"
                    label="Select Branch"
                    options={branchList}
                    onChange={(selected) => {
                      setSelectedTenant({...selected})
                      
                      if (selected?.id) {
                        
                        formik.setFieldValue("tenant_id", selected?.id);
                      }
                    }}
                    value={formik?.values?.tenant_id}
                    error={
                      formik.touched.tenant_id && formik.errors.tenant_id
                    }
                    isImportant={_.get(userData,"role_id") ==1}
                    onBlur={formik.handleBlur}
                    disabled={_.get(userData,"role_id") !=1}
                  />
                  {formik.touched.tenant_id && (
                    <ErrorLabel
                      name="tenant_id"
                      formik={formik}
                      message={formik.errors.tenant_id}
                    />
                  )}
                </div>
                
                <div className="col-md-4 mb-2">
                    <FormDropdown
                      id="service"
                      name="service"
                      label="Services"
                      options={serviceTypes}
                      onChange={(selected) => {
                        setSelectedServiceType(selected)
                        formik.setFieldValue("service", selected?.id);
                      }}
                      isImportant={true}
                      value={formik.values.service}
                      error={formik.touched.service && formik.errors.service}
                      onBlur={formik.handleBlur}
                      //className={styles.formField}
                    />
                    {formik.touched.service && (
                      <ErrorLabel
                        name="service"
                        formik={formik}
                        message={formik.errors.service}
                      />
                    )}
                  </div>
          
                
              </div>
              <div className="row justify-content-end w-100">
            <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
              <CancelButton label="Cancel" onClick={()=>setOpenForm(0)} className="btn btn-secondary" />
              <PrimaryButton
                type="submit"
                onClick={formik.handleSubmit}
                spinner={isSpinner}
                label={_.get(selectedRow,"id")?"Update":"Submit"}
                disabled={!(formik.dirty && formik.isValid)}
              />
            </div>
          </div>
            </div>
          
          </Card>
          
          </> }
        </div>
    </div>
  )
}
